import Vue from 'vue'
import DialogPanel from 'components/dialogPanel'
import SelectTmpl from 'components/selectTmpl'
import MyTable from 'components/myTable'
import Pagination from 'components/pagination'
import DragTreeTable from 'components/dragTreeTable'
import ContextMenu from 'components/context-menu'
import myTree from 'components/myTree'
import tableBody from 'components/tableBody'
import treeDialog from 'components/treeDialog'
import FlexBox from 'components/flexBox'
import DemandTree from 'components/demandTree'
import ReportTable from 'components/reportTable'
import MulSelect from 'components/mulSelect/multipleSelect'


Vue.component('dialog-panel', DialogPanel)
Vue.component('select-tmpl', SelectTmpl)
Vue.component('my-table', MyTable)
Vue.component('pagination', Pagination)
Vue.component('dragTreeTable', DragTreeTable)
Vue.component('contextMenu', ContextMenu)
Vue.component('myTree', myTree)
Vue.component('tableBody', tableBody)
Vue.component('treeDialog', treeDialog)
Vue.component('flex-box', FlexBox)
Vue.component('demandTree', DemandTree)
Vue.component('reportTable', ReportTable)
Vue.component('mulSelect', MulSelect)

Vue.prototype.webTitle = 'EPM项目管理系统'



// WEBPACK FOOTER //
// ./src/common/index.js